import React from 'react'
import { connect } from 'react-redux'
import CouponForm from './CouponForm'

import {
  clear_coupon,
} from '../actions'

const mapStateToProps = state => {
  return {

  }
}
const mapDispatchToProps = dispatch => {
  return {
    clearCoupon: () => dispatch( clear_coupon() ),
  }
}

class ConnectedCouponNew extends React.Component {
  componentWillMount() {
    this.props.clearCoupon()
  }

  render(){
    return <CouponForm actionName="create"/>
  }
}

const CouponNew = connect(mapStateToProps, mapDispatchToProps)(ConnectedCouponNew)
export default CouponNew



// WEBPACK FOOTER //
// ./src/js/components/CouponNew.js